import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
  import _ from "lodash";
  import React from "react";
import { useStyle } from "./style";
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
  const ModalTable = ({tableHeadData , tableBodyData,setOpen,data}) => {
    console.log(data,"view data")
    console.log(tableBodyData,"tableBodyData");
    
 const classes = useStyle()
 const location = useLocation()
 const currentPath = location.pathname;
    return ( 
      <Grid sx={{ backgroundColor: "#fff",padding:"10px",maxHeight:"500px" ,overflowY:"auto"}}>
        <div className="flex justify-between">
          {data && 
          <Grid className="my-1">
            <Typography sx={{marginBlock:.5}}>Bill No : <strong>{data.documentNo}</strong></Typography>
            <Typography>Bill Date : <strong>{data.documentDate}</strong></Typography>
          </Grid>
          }
          {currentPath == "/reports/outletSalesReport" && data &&
          <>
            <div className="flex my-1" style={{flexDirection:"column"}}>
            <Typography >Sales Man : <strong>{data.sales_man_name}</strong> - <strong>{data.sales_man_code}</strong> </Typography>
             <Typography>Payment Mode : <strong>{data.mode}</strong></Typography>
          </div>
          </>
          }
          <IconButton size="small" sx={{marginBlockEnd:2,}} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <TableContainer className={classes.tblRoot} sx={{width: '100%',maxHeight: 400, overflow:"auto"}} >
          <Table stickyHeader className={classes.table} sx={{ maxHeight: 350, overflowY: 'auto'  }}>
            <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
              <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                {tableHeadData.map((item) => (
                  <TableCell className={classes.tblCell} sx={{color:"#fff"}} key={item.id}>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
        {currentPath !== "/reports/purchase" && currentPath !== "/reports/otPurchaseReturnReport" && tableBodyData && tableBodyData.map((val) => (
              <>
                  <TableRow className={classes.tablrow}  key={val.id}>
                <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
                <TableCell>{val.name || val.pro_name}</TableCell>
                <TableCell>{val.Mrp}</TableCell>
                <TableCell>{val.gstAmnt}</TableCell>
                {currentPath !=  "/reports/salesReport" && <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{val.splDiscount}</TableCell>}

                {/* <TableCell>{val.splDiscount}</TableCell> */}
                <TableCell>{val.gstPer}</TableCell>
                {currentPath !=  "/reports/salesReport" && currentPath !=  "/reports/otSalesReturnReport" && <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{val.disPer}</TableCell>}
{/* 
                <TableCell>{val.disPer}</TableCell> */}

                <TableCell>{val.Qty}</TableCell>
                {currentPath !=  "/reports/purchase" && <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{parseFloat(val.Rate).toFixed(0)}</TableCell>}
                {/* {currentPath !=  "/reports/purchase" && <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{parseFloat(val.Rate).toFixed(2)}</TableCell>} */}
               {/* {currentPath != "/reports/salesReport" &&<TableCell  sx={{textAlign:"right !important" , fontWeight:600}}>{val.totalAmount}</TableCell>} */}
               <TableCell  sx={{textAlign:"right !important" , fontWeight:600}}>{val.splDiscount === val.Mrp ? val.splDiscount : val.totalAmount}</TableCell>
               {/* <TableCell  sx={{textAlign:"right !important" , fontWeight:600}}>{val.totalAmount}</TableCell> */}
              </TableRow>
              </>
            ))}
         {currentPath === "/reports/purchase" && tableBodyData && tableBodyData.map((val) => (
  <TableRow className={classes.tablrow} key={val.id}>
    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
    <TableCell>{val.name || val.pro_name}</TableCell>
    <TableCell>{val.Mrp}</TableCell>
    <TableCell>{val.gstAmnt}</TableCell>
    <TableCell>{val.gstPer}</TableCell>
    <TableCell>{val.Qty}</TableCell>
    {/* {currentPath !== "/reports/purchase" && <TableCell sx={{textAlign:"right !important", fontWeight: 600}}>{parseFloat(val.Rate).toFixed(2)}</TableCell>} */}
    <TableCell sx={{textAlign:"right !important", fontWeight: 600}}>{val.totalAmount}</TableCell>
  </TableRow>
))}
{currentPath === "/reports/otPurchaseReturnReport" && tableBodyData && tableBodyData.map((val) => (
  <TableRow className={classes.tablrow} key={val.id}>
    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
    <TableCell>{val.name}</TableCell>
    <TableCell>{val.pro_name}</TableCell>
    <TableCell sx={{textAlign:"right !important", fontWeight: 600}}>{parseFloat(val.Rate || 0).toFixed(2)}</TableCell>
    <TableCell>{val.Qty}</TableCell>
    <TableCell sx={{textAlign:"right !important", fontWeight: 600}}>{val.totalAmount}</TableCell>
    <TableCell>{val.reason}</TableCell>
  </TableRow>
))}

            </TableBody>
          </Table>
        </TableContainer>
        {data &&
        <Grid className="flex justify-between">
        <Grid>
          {data.lessAmount > 0 && <Typography sx={{textAlign:"end",padding:1}}>Less Amount : <strong>{parseFloat(data.lessAmount ).toFixed(2)}</strong></Typography>}
          {data.loyalty_redem > 0 && <Typography sx={{textAlign:"end",padding:1}}>Redeem Amount : <strong>{parseFloat(data.loyalty_redem ).toFixed(2)}</strong></Typography>}
          {data.RetAmt > 0 && <Typography sx={{textAlign:"end",padding:1}}>Return Amount : <strong>{parseFloat(data.RetAmt ).toFixed(2)}</strong></Typography>}
        </Grid>
        <Grid>
        {/* {currentPath !== "/reports/otSalesReturnReport" && (
              <Typography sx={{ textAlign: "end", padding: 1 }}>
                Discount Amount :{" "}
                <strong>{parseFloat(data.splDiscount).toFixed(2)}</strong>
              </Typography>
            )} */}
        {currentPath != "/reports/salesReport" && data.splDiscount > 0 && <Typography sx={{textAlign:"end",padding:1}}>Discount Amount : <strong>{parseFloat(data.splDiscount ).toFixed(2)}</strong></Typography>}
{/* {currentPath != "/reports/outletSalesReport" &&<Typography sx={{textAlign:"end",padding:1}}>Total Amount : <strong>{Math.round(data.tot_amt - data.splDiscount || data.tot_amt)}</strong></Typography>
}        */}
 <Typography sx={{textAlign:"end",padding:1}}>Total Amount : <strong>{Math.round(data.tot_amt)}</strong></Typography>
        </Grid>
        </Grid>
        }

      </Grid>
    );
  };
  
  export default ModalTable;